import { object, string } from "yup";

export interface PortalCustomerLogin {
  email: string;
  password: string;
  dmsSetupId: string;
}

export interface PortalCreateCustomer {
  email: string;
  password: string;
  dmsSetupId: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export const portalLoginDefault: PortalCustomerLogin = {
  email: "",
  password: "",
  dmsSetupId: "",
};

export const PortalLoginValidationSchema = object().shape({
  email: string().email("Enter a valid email").required("Please enter Email"),
  password: string()
    .required("Please enter a password")
    .min(8, "Password must have at least 8 characters"),
});

export const portalSignupDefault: PortalCreateCustomer = {
  email: "",
  password: "",
  dmsSetupId: "",
  firstName: "",
  lastName: "",
  phone: "",
};

export const PortalSignupValidationSchema = object().shape({
  email: string().email("Enter a valid email").required("Please enter Email"),
  firstName: string().required("First Name is required"),
  lastName: string().required("Last Name is required"),
  phone: string().required("Phone is required"),
  password: string()
    .required("Please enter a password")
    .min(8, "Password must have at least 8 characters"),
});
